import { getLocalStorageItem } from 'collaboration-sidebar/utils/localStorage';
export function isOnboardingTourSeleniumRunning() {
  return !!getLocalStorageItem('selenium_onboarding_tour_enabled');
}
export function shouldHideOnboardingForSelenium() {
  const isSeleniumRunning = document.cookie.includes('hs_selenium');
  return isSeleniumRunning && !isOnboardingTourSeleniumRunning();
}